<template>
    <el-row :gutter="15">
        <template v-for="(item,index) in list" >
            <el-col v-bind:key="index" :span="item.rowspan ? item.rowspan:span" v-if="!autoComplete && item.buttonType === 'input'">
                <div class="form-list" :style="{paddingLeft:labelWidth}">
                    <div class="form-label" :style="{width:labelWidth,cursor: isClickLabel ? 'pointer' : 'default' }" @click="clickLabel(item)">
                        <template v-if="!!isI18n">
                            {{$t(item.text)}}：
                        </template>
                        <template v-else>
                            {{item.text}}：
                        </template>    
                    </div>
                    <div class="form-input">
                        <el-row :gutter="15">
                            <el-col :span="deleteBtn ? 21 : 24">
                                <template v-if="!!isI18n">
                                    <el-input v-model="item.content" :placeholder="$t(item.placeholder)" :size="size" 
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000" :show-word-limit="item.showWordLimit"
                                    @change="change(item)"  @keyup.enter.native="keyUpEvent"></el-input>
                                </template>    
                                <template v-else>
                                    <el-input v-model="item.content" :placeholder="item.placeholder" :size="size" 
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000" :show-word-limit="item.showWordLimit"
                                    @change="change(item)"  @keyup.enter.native="keyUpEvent"></el-input>
                                </template>
                            </el-col>
                            <el-col :span="3" v-if="deleteBtn">
                                <el-button :size="size" icon="el-icon-delete" @click="deleteItem(item)"></el-button>                        
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>

            <el-col v-bind:key="index" :span="item.rowspan ? item.rowspan:span" v-if="!autoComplete && item.buttonType === 'selectSearchInput'">
                <div class="form-list" :style="{paddingLeft:labelWidth}">
                    <div class="form-label" :style="{width:labelWidth,cursor: isClickLabel ? 'pointer' : 'default' }" @click="clickLabel(item)">
                         <template v-if="!!isI18n">
                            {{$t(item.text)}}：
                        </template>
                        <template v-else>
                            {{item.text}}：
                        </template>
                    </div>
                    <div class="form-input">
                        <el-row :gutter="15">
                            <el-col :span="deleteBtn ? 21 : 24">
                                <template v-if="!!isI18n">
                                    <el-input class="input-with-select" v-model="item.content2" :placeholder="$t(item.placeholder)" :size="size" 
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000" :show-word-limit="item.showWordLimit"
                                    @change="change(item)"  @keyup.enter.native="keyUpEvent">
                                        <el-select :clearable="clearable" v-model="item.content1" slot="prepend" placeholder="请选择" :size="size" style="width:80px;" @change="change(item)">
                                            <template v-if="!!item.options">
                                                <el-option v-for="o in item.options"
                                                            :key="o.value"
                                                            :label="$t(o.label)"
                                                            :value="o.value"></el-option>
                                            </template>   
                                        </el-select>
                                        <el-button slot="append" icon="el-icon-search" @click="search(item)"></el-button>
                                    </el-input>
                                </template>
                                <template v-else>
                                    <el-input class="input-with-select" v-model="item.content2" :placeholder="item.placeholder" :size="size" 
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000" :show-word-limit="item.showWordLimit"
                                    @change="change(item)"  @keyup.enter.native="keyUpEvent">
                                        <el-select :clearable="clearable" v-model="item.content1" slot="prepend" placeholder="请选择" :size="size" style="width:80px;" @change="change(item)">
                                            <template v-if="!!item.options">
                                                <el-option v-for="o in item.options"
                                                            :key="o.value"
                                                            :label="o.label"
                                                            :value="o.value"></el-option>
                                            </template>   
                                        </el-select>
                                        <el-button slot="append" icon="el-icon-search" @click="search(item)"></el-button>
                                    </el-input>
                                </template>
                               
                            </el-col>
                            <el-col :span="3" v-if="deleteBtn">
                                <el-button :size="size" icon="el-icon-delete" @click="deleteItem(item)"></el-button>                        
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>

            <el-col v-bind:key="index" :span="item.rowspan ? item.rowspan:span" v-if="autoComplete && item.buttonType === 'selectSearchInput'">
                <div class="form-list" :style="{paddingLeft:labelWidth}">
                    <div class="form-label" :style="{width:labelWidth,cursor: isClickLabel ? 'pointer' : 'default' }" @click="clickLabel(item)">
                        <template v-if="!!isI18n">
                            {{$t(item.text)}}：
                        </template>
                        <template v-else>
                            {{item.text}}：
                        </template>
                    </div>
                    <div class="form-input">
                        <el-row :gutter="15">
                            <el-col :span="deleteBtn ? 21 : 24">
                                <template v-if="!!isI18n">
                                    <el-autocomplete  class="input-with-select"
                                    :size="size" v-model="item.content2"
                                    :fetch-suggestions="querySearchAsync"
                                    :placeholder="$t(item.placeholder)"
                                    @keyup.enter.native="keyUpEvent"
                                    @select="handleSelect(item)"
                                    @focus="handleFocus(item)"
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000"
                                    :show-word-limit="item.showWordLimit"
                                    >
                                        <el-select slot="prepend" :clearable="clearable" v-model="item.content1" placeholder="请选择" :size="size" style="width:80px;" @change="change(item)">
                                            <template v-if="!!item.options">
                                            <el-option v-for="o in item.options"
                                                        :key="o.value"
                                                        :label="$t(o.label)"
                                                        :value="o.value"></el-option>
                                            </template>   
                                        </el-select>
                                        <el-button slot="append" icon="el-icon-search" @click="search(item)"></el-button>
                                    </el-autocomplete>
                                </template>
                                <template>
                                    <el-autocomplete  class="input-with-select"
                                    :size="size" v-model="item.content2"
                                    :fetch-suggestions="querySearchAsync"
                                    :placeholder="item.placeholder"
                                    @keyup.enter.native="keyUpEvent"
                                    @select="handleSelect(item)"
                                    @focus="handleFocus(item)"
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000"
                                    :show-word-limit="item.showWordLimit"
                                    >
                                        <el-select slot="prepend" :clearable="clearable" v-model="item.content1" placeholder="请选择" :size="size" style="width:80px;" @change="change(item)">
                                            <template v-if="!!item.options">
                                            <el-option v-for="o in item.options"
                                                        :key="o.value"
                                                        :label="o.label"
                                                        :value="o.value"></el-option>
                                            </template>   
                                        </el-select>
                                        <el-button slot="append" icon="el-icon-search" @click="search(item)"></el-button>
                                    </el-autocomplete>
                                </template>
                              
                            </el-col>
                            <el-col :span="3" v-if="deleteBtn">
                                <el-button :size="size" icon="el-icon-delete" @click="deleteItem(item)"></el-button>                        
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>

            <el-col v-bind:key="index" :span="item.rowspan ? item.rowspan:span" v-if="!autoComplete && item.buttonType === 'selectInput'">
                <div class="form-list" :style="{paddingLeft:labelWidth}">
                    <div class="form-label" :style="{width:labelWidth,cursor: isClickLabel ? 'pointer' : 'default' }" @click="clickLabel(item)">
                        <template v-if="!!isI18n">
                            {{$t(item.text)}}：
                        </template>
                        <template v-else>
                            {{item.text}}：
                        </template>    
                    </div>
                    <div class="form-input">
                        <el-row :gutter="15">
                            <el-col :span="deleteBtn ? 21 : 24">
                                <template v-if="!!isI18n">
                                    <el-input class="input-with-select" v-model="item.content2" :placeholder="$t(item.placeholder)" :size="size" 
                                        :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000" :show-word-limit="item.showWordLimit"
                                        @change="change(item)"  @keyup.enter.native="keyUpEvent">
                                            <el-select :clearable="clearable" v-model="item.content1" slot="prepend" placeholder="请选择" :size="size" style="width:80px;" @change="change(item)">
                                                <template v-if="!!item.options">
                                                    <el-option v-for="o in item.options"
                                                                :key="o.value"
                                                                :label="$t(o.label)"
                                                                :value="o.value"></el-option>
                                                </template>   
                                            </el-select>
                                    </el-input>
                                </template>
                                <template v-else>
                                    <el-input class="input-with-select" v-model="item.content2" :placeholder="item.placeholder" :size="size" 
                                        :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000" :show-word-limit="item.showWordLimit"
                                        @change="change(item)"  @keyup.enter.native="keyUpEvent">
                                            <el-select :clearable="clearable" v-model="item.content1" slot="prepend" placeholder="请选择" :size="size" style="width:80px;" @change="change(item)">
                                                <template v-if="!!item.options">
                                                    <el-option v-for="o in item.options"
                                                                :key="o.value"
                                                                :label="o.label"
                                                                :value="o.value"></el-option>
                                                </template>   
                                            </el-select>
                                    </el-input>
                                </template>
                               
                            </el-col>
                            <el-col :span="3" v-if="deleteBtn">
                                <el-button :size="size" icon="el-icon-delete" @click="deleteItem(item)"></el-button>                        
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>

            <el-col v-bind:key="index" :span="item.rowspan ? item.rowspan:span" v-if="autoComplete && item.buttonType === 'selectInput'">
                <div class="form-list" :style="{paddingLeft:labelWidth}">
                    <div class="form-label" :style="{width:labelWidth,cursor: isClickLabel ? 'pointer' : 'default' }" @click="clickLabel(item)">
                        <template v-if="!!isI18n">  {{$t(item.text)}}：</template>
                        <template v-else>  {{item.text}}：</template>
                    </div>
                    <div class="form-input">
                        <el-row :gutter="15">
                            <el-col :span="deleteBtn ? 21 : 24">
                                <template  v-if="!!isI18n">
                                    <el-autocomplete  class="input-with-select"
                                    :size="size" v-model="item.content2"
                                    :fetch-suggestions="querySearchAsync"
                                    :placeholder="$t(item.placeholder)"
                                    @keyup.enter.native="keyUpEvent"
                                    @select="handleSelect(item)"
                                    @focus="handleFocus(item)"
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000"
                                    :show-word-limit="item.showWordLimit"
                                    >
                                        <el-select slot="prepend" :clearable="clearable" v-model="item.content1" placeholder="请选择" :size="size" style="width:80px;" @change="change(item)">
                                            <template v-if="!!item.options">
                                            <el-option v-for="o in item.options"
                                                        :key="o.value"
                                                        :label="$t(o.label)"
                                                        :value="o.value"></el-option>
                                            </template>   
                                        </el-select>
                                    </el-autocomplete>
                                </template>
                                <template v-else>
                                        <el-autocomplete  class="input-with-select"
                                    :size="size" v-model="item.content2"
                                    :fetch-suggestions="querySearchAsync"
                                    :placeholder="item.placeholder"
                                    @keyup.enter.native="keyUpEvent"
                                    @select="handleSelect(item)"
                                    @focus="handleFocus(item)"
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000"
                                    :show-word-limit="item.showWordLimit"
                                    >
                                        <el-select slot="prepend" :clearable="clearable" v-model="item.content1" placeholder="请选择" :size="size" style="width:80px;" @change="change(item)">
                                            <template v-if="!!item.options">
                                            <el-option v-for="o in item.options"
                                                        :key="o.value"
                                                        :label="o.label"
                                                        :value="o.value"></el-option>
                                            </template>   
                                        </el-select>
                                    </el-autocomplete>
                                </template>
                            </el-col>
                            <el-col :span="3" v-if="deleteBtn">
                                <el-button :size="size" icon="el-icon-delete" @click="deleteItem(item)"></el-button>                        
                            </el-col>
                        </el-row>
                       
                    </div>
                </div>
            </el-col>

             <el-col v-bind:key="index" :span="item.rowspan ? item.rowspan:span" v-if="autoComplete && item.buttonType === 'input'">
                <div class="form-list" :style="{paddingLeft:labelWidth}">
                    <div class="form-label" :style="{width:labelWidth,cursor: isClickLabel ? 'pointer' : 'default' }" @click="clickLabel(item)">
                        <template v-if="!!isI18n">  {{$t(item.text)}}：</template>
                        <template v-else>  {{item.text}}：</template>
                    </div>
                    <div class="form-input">
                        <el-row :gutter="15">
                            <el-col :span="deleteBtn ? 21 : 24">
                                <template v-if="!!isI18n">
                                    <el-autocomplete
                                    :size="size"
                                    v-model="item.content"
                                    :fetch-suggestions="querySearchAsync"
                                    :placeholder="$t(item.placeholder)"
                                    @keyup.enter.native="keyUpEvent"
                                    @select="handleSelect(item)"
                                    @focus="handleFocus(item)"
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000"
                                    :show-word-limit="item.showWordLimit"
                                    ></el-autocomplete>
                                </template>
                                <template v-else>
                                    <el-autocomplete
                                    :size="size"
                                    v-model="item.content"
                                    :fetch-suggestions="querySearchAsync"
                                    :placeholder="item.placeholder"
                                    @keyup.enter.native="keyUpEvent"
                                    @select="handleSelect(item)"
                                    @focus="handleFocus(item)"
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000"
                                    :show-word-limit="item.showWordLimit"
                                    ></el-autocomplete>
                                </template>
                            </el-col>
                            <el-col :span="3" v-if="deleteBtn">
                                <el-button :size="size" icon="el-icon-delete" @click="deleteItem(item)"></el-button>                        
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>

             <el-col v-bind:key="index" :span="item.rowspan ? item.rowspan:span" v-if="item.buttonType === 'checkbox'">
                <div class="form-list" :style="{paddingLeft:labelWidth}">
                    <div class="form-label" :style="{width:labelWidth,cursor: isClickLabel ? 'pointer' : 'default' }" @click="clickLabel(item)">
                        <template v-if="!!isI18n">  {{$t(item.text)}}：</template>
                        <template v-else>  {{item.text}}：</template>
                    </div>
                    <div class="form-input">
                        <el-row :gutter="15">
                            <el-col :span="deleteBtn ? 21 : 24">
                                <template v-if="!!isI18n">
                                    <el-checkbox-group v-model="item.checked" @change="change(item)">
                                        <el-checkbox v-for="ce in item.list" :label="ce" :key="ce">{{$t(ce)}}</el-checkbox>
                                    </el-checkbox-group>
                                </template>
                                <template v-else>
                                    <el-checkbox-group v-model="item.checked" @change="change(item)">
                                        <el-checkbox v-for="ce in item.list" :label="ce" :key="ce">{{ce}}</el-checkbox>
                                    </el-checkbox-group>
                                </template>
                            </el-col>
                            <el-col :span="3" v-if="deleteBtn">
                                <el-button :size="size" icon="el-icon-delete" @click="deleteItem(item)"></el-button>                        
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>

            <el-col v-bind:key="index" :span="item.rowspan ? item.rowspan:span" v-if="item.buttonType === 'date'">
                <div class="form-list" :style="{paddingLeft:labelWidth}">
                    <div class="form-label" :style="{width:labelWidth,cursor: isClickLabel ? 'pointer' : 'default' }" @click="clickLabel(item)">
                        <template v-if="!!isI18n">  {{$t(item.text)}}：</template>
                        <template v-else>  {{item.text}}：</template>
                    </div>
                    <div class="form-input">
                        <el-row :gutter="15">
                            <el-col :span="deleteBtn ? 21 : 24">
                                <ip-date-picker :defaultValue="item.content" @change="dateChange('content',item,arguments)">
                                </ip-date-picker>
                            </el-col>
                            <el-col :span="3" v-if="deleteBtn">
                                <el-button :size="size" icon="el-icon-delete" @click="deleteItem(item)"></el-button>                        
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>

            <el-col v-bind:key="index" :span="item.rowspan ? item.rowspan:span" v-if="item.buttonType === 'dateRange'">
                <div class="form-list" :style="{paddingLeft:labelWidth}">
                    <div class="form-label" :style="{width:labelWidth,cursor: isClickLabel ? 'pointer' : 'default' }" @click="clickLabel(item)">
                        <template v-if="!!isI18n">  {{$t(item.text)}}：</template>
                        <template v-else>  {{item.text}}：</template>
                    </div>
                    <div class="form-input">
                        <el-row>
                            <el-col :span="11">
                                <ip-date-picker :defaultValue="item.content1" @change="dateChange('content1',item,arguments)">
                                </ip-date-picker>
                            </el-col>
                            <el-col class="line" :span="2">-</el-col>
                            <el-col :span="11">
                                <ip-date-picker :defaultValue="item.content2" @change="dateChange('content2',item,arguments)">
                                </ip-date-picker>
                            </el-col>    
                        </el-row>                              
                    </div>
                </div>
            </el-col>

            <el-col v-bind:key="index" :span="item.rowspan ? item.rowspan:span" v-if="!autoComplete && item.buttonType === 'searchInput'">
                <div class="form-list" :style="{paddingLeft:labelWidth}">
                    <div class="form-label" :style="{width:labelWidth,cursor: isClickLabel ? 'pointer' : 'default' }" @click="clickLabel(item)">
                        <template v-if="!!isI18n">  {{$t(item.text)}}：</template>
                        <template v-else>  {{item.text}}：</template>
                    </div>
                    <div class="form-input">
                        <el-row :gutter="15">
                            <el-col :span="deleteBtn ? 21 : 24">
                                 <template v-if="!!isI18n"> 
                                    <el-input v-model="item.content" :size="size" @change="change(item)" :placeholder="$t(item.placeholder)"  @keyup.enter.native="keyUpEvent"
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000"
                                    :show-word-limit="item.showWordLimit">
                                        <el-button slot="append" :icon="!!item.icon ? item.icon : 'el-icon-search'" @click="search(item)"></el-button>
                                    </el-input>   
                                 </template>
                                 <template v-else>
                                    <el-input v-model="item.content" :size="size" @change="change(item)" :placeholder="item.placeholder"  @keyup.enter.native="keyUpEvent"
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000"
                                    :show-word-limit="item.showWordLimit">
                                        <el-button slot="append" :icon="!!item.icon ? item.icon : 'el-icon-search'" @click="search(item)"></el-button>
                                    </el-input>   
                                 </template>
                                
                            </el-col>
                            <el-col :span="3" v-if="deleteBtn">
                                <el-button :size="size" icon="el-icon-delete" @click="deleteItem(item)"></el-button>                        
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>

             <el-col v-bind:key="index" :span="item.rowspan ? item.rowspan:span" v-if="autoComplete && item.buttonType === 'searchInput'">
                <div class="form-list" :style="{paddingLeft:labelWidth}">
                    <div class="form-label" :style="{width:labelWidth,cursor: isClickLabel ? 'pointer' : 'default' }" @click="clickLabel(item)">
                        <template v-if="!!isI18n">  {{$t(item.text)}}：</template>
                        <template v-else>  {{item.text}}：</template>
                    </div>
                    <div class="form-input">
                        <el-row :gutter="15">
                            <el-col :span="deleteBtn ? 21 : 24">
                                <template v-if="!!isI18n">
                                    <el-autocomplete :size="size" v-model="item.content" :fetch-suggestions="querySearchAsync" :placeholder="$t(item.placeholder)" @keyup.enter.native="keyUpEvent" @select="handleSelect(item)" @focus="handleFocus(item)"
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000"
                                    :show-word-limit="item.showWordLimit">
                                        <el-button slot="append" icon="el-icon-search" @click="search(item)"></el-button>
                                    </el-autocomplete>
                                </template>
                                <template v-else>
                                    <el-autocomplete :size="size" v-model="item.content" :fetch-suggestions="querySearchAsync" :placeholder="item.placeholder" @keyup.enter.native="keyUpEvent" @select="handleSelect(item)" @focus="handleFocus(item)"
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000"
                                    :show-word-limit="item.showWordLimit">
                                        <el-button slot="append" icon="el-icon-search" @click="search(item)"></el-button>
                                    </el-autocomplete>
                                </template>
                            </el-col>
                            <el-col :span="3" v-if="deleteBtn">
                                <el-button :size="size" icon="el-icon-delete" @click="deleteItem(item)"></el-button>                        
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>

            <el-col v-bind:key="index" :span="item.rowspan ? item.rowspan:span" v-if="item.buttonType === 'textarea'">
                <div class="form-list" :style="{paddingLeft:labelWidth}">
                    <div class="form-label" :style="{width:labelWidth,cursor: isClickLabel ? 'pointer' : 'default' }" @click="clickLabel(item)">
                        <template v-if="!!isI18n">  {{$t(item.text)}}：</template>
                        <template v-else>  {{item.text}}：</template>
                    </div>
                    <div class="form-input">
                        <el-row :gutter="15">
                            <el-col :span="deleteBtn ? 21 : 24">
                                <template v-if="!!isI18n">
                                    <el-input type="textarea" :autosize="item.autosize" v-model="item.content" :placeholder="$t(item.placeholder)" @change="change(item)"
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000"
                                    :show-word-limit="item.showWordLimit"></el-input>
                                </template>
                                <template v-else>
                                    <el-input type="textarea" :autosize="item.autosize" v-model="item.content" :placeholder="item.placeholder" @change="change(item)"
                                    :maxlength="(item.maxlength&&item.maxlength>0)?item.maxlength:1000"
                                    :show-word-limit="item.showWordLimit"></el-input>
                                </template>
                            </el-col>
                            <el-col :span="3" v-if="deleteBtn">
                                <el-button :size="size" icon="el-icon-delete" @click="deleteItem(item)"></el-button>                        
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>

            <el-col v-bind:key="index" :span="item.rowspan ? item.rowspan:span" v-if="item.buttonType === 'select'">
                <div class="form-list" :style="{paddingLeft:labelWidth}">
                    <div class="form-label" :style="{width:labelWidth,cursor: isClickLabel ? 'pointer' : 'default' }" @click="clickLabel(item)">
                        <template v-if="!!isI18n">  {{$t(item.text)}}：</template>
                        <template v-else>  {{item.text}}：</template>
                    </div>
                    <div class="form-input">
                        <el-row :gutter="15">
                            <el-col :span="deleteBtn ? 21 : 24">
                                 <template v-if="!!isI18n">
                                      <el-select :clearable="clearable" v-model="item.content" :placeholder="$t(item.placeholder)" :size="size" 
                                    style="width:auto;" @change="change(item)">
                                        <template v-if="!!item.options">
                                        <el-option v-for="o in item.options"
                                                    :key="o.value"
                                                    :label="$t(o.label)"
                                                    :value="o.value"></el-option>
                                        </template>   
                                    </el-select>
                                 </template>
                                 <template v-else>
                                    <el-select :clearable="clearable" v-model="item.content" :placeholder="item.placeholder" :size="size" 
                                    style="width:auto;" @change="change(item)">
                                        <template v-if="!!item.options">
                                        <el-option v-for="o in item.options"
                                                    :key="o.value"
                                                    :label="o.label"
                                                    :value="o.value"></el-option>
                                        </template>   
                                    </el-select>
                                 </template>
                            </el-col>
                            <el-col :span="3" v-if="deleteBtn">
                                <el-button :size="size" icon="el-icon-delete" @click="deleteItem(item)"></el-button>                        
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>

            <el-col v-bind:key="index" :span="item.rowspan ? item.rowspan:span" v-if="item.buttonType === 'custom'">
                <div class="form-list" :style="{paddingLeft:labelWidth}">
                    <div class="form-label" :style="{width:labelWidth,cursor: isClickLabel ? 'pointer' : 'default' }" @click="clickLabel(item)">
                        <template v-if="!!isI18n">  {{$t(item.text)}}：</template>
                        <template v-else>  {{item.text}}：</template>
                    </div>
                    <div class="form-input">
                        <el-row :gutter="15">
                            <el-col :span="deleteBtn ? 21 : 24">
                                <slot name="custom" :data="item"></slot>
                            </el-col>
                            <el-col :span="3" v-if="deleteBtn">
                                    <el-button :size="size" icon="el-icon-delete" @click="deleteItem(item)"></el-button>                        
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>
        </template>
    </el-row>
</template>
<script>
export default {
    name:'ipSearchCondition',
    props:{
        list:{
            type:Array,
            default:function(){
                return []
            },
            required:true
        },
        row:{
            type:String,
            default:'2',
        },
        labelWidth:{
            type:String,
            default:'130px',
        },
        size:{
            type:String,
            default:'small'
        },
        valueFormat:{
            type:String,
            default:'yyyy.MM.dd'
        },
        isClickLabel:{
            type:Boolean,
            default:false
        },
        autoComplete:{
            type:Boolean,
            default:false
        },
        autoList:{
            type:Array,
            default:function(){
                return []
            }
        },
        deleteBtn:{
            type:Boolean,
            default:false
        },
        isI18n:{type:Boolean,default:false},
        clearable:{type:Boolean,default:false}
    },
    computed:{
        span(){
            return 24/Number(this.row)
        }
    },
    data(){
        return{
            timeout:  null
        }
    },
    methods:{
        deleteItem(item){
            this.$emit('delete-item',item);
        },
        keyUpEvent(){
            this.$emit('key-up-event');
        },
        search(value){
            this.$emit('search-event',value);
        },
        change(item){
            this.$emit('change',item);
        },
        dateChange(tag,item,data){
            if(tag === 'content1'){
                item.content1 = data[0];
            }else if(tag === 'content2'){
                item.content2 = data[0];
            }else{
                item.content = data[0];
            }
             this.$emit('change',item);
        },
        clickLabel(item){
            if (this.isClickLabel) {
                   this.$emit('click-label',item);
            }
        },
        querySearchAsync(queryString, callback) {
            const self = this;
            clearTimeout(self.timeout);
            self.timeout = setTimeout(() => {
                callback(self.autoList);
            }, 20);
            self.$emit('query-search',queryString);
        },
        handleSelect(item){
            this.$emit('query-select',item);
        },
        handleFocus(item){
            this.$emit('focus',item);
        }
    }
}
</script>
<style lang="scss" scoped>
.form-list {
        position: relative;
        padding-left: 134px;
        margin: 8px 0;
    .form-label {
        position: absolute;
        top: 0;
        left: 0;
        width: 130px;
        padding-right: 5px;
        box-sizing: border-box;
        text-align: right;
        line-height: 30px;
        font-size: 14px;
        display: table-cell;
        display: inline-block;
        vertical-align: middle;
    }
     .form-input {
        .el-checkbox-group {
            padding: 5px 0 0 0;
            height: 32px;
            box-sizing: border-box;
        }
        .el-date-editor{
            width: 100%;
        }
        .line{
            text-align: center;
        }
        .el-autocomplete{
            width: 100%;
        }
    }
}
</style>

